// City-specific configurations for Google Ads landing pages
// Each variant customizes the H1, subtitle, zone, and form pre-fill

export const cityConfigs = {
  'hauts-de-france': {
    cityName: 'Hauts-de-France',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'dans les Hauts-de-France',
    subtitle: 'Les Façadiers HDF vous accompagnent pour vos travaux de rénovation et de ravalement de façade. Étude de votre projet et devis gratuit.',
    metaTitle: 'Ravalement de façade Hauts-de-France | Devis gratuit | Les Façadiers HDF',
    defaultVille: '',
    highlightDept: null,
  },
  'amiens': {
    cityName: 'Amiens',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'à Amiens',
    subtitle: 'Les Façadiers HDF réalisent vos travaux de ravalement et rénovation de façade à Amiens et dans la Somme. Devis gratuit après visite sur site.',
    metaTitle: 'Ravalement de façade Amiens | Devis gratuit | Les Façadiers HDF',
    defaultVille: 'Amiens',
    highlightDept: 'Somme (80)',
  },
  'abbeville': {
    cityName: 'Abbeville',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'à Abbeville',
    subtitle: 'Les Façadiers HDF réalisent vos travaux de ravalement et rénovation de façade à Abbeville et dans la Somme. Devis gratuit après visite sur site.',
    metaTitle: 'Ravalement de façade Abbeville | Devis gratuit | Les Façadiers HDF',
    defaultVille: 'Abbeville',
    highlightDept: 'Somme (80)',
  },
  'peronne': {
    cityName: 'Péronne',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'à Péronne',
    subtitle: 'Les Façadiers HDF réalisent vos travaux de ravalement et rénovation de façade à Péronne et dans la Somme. Devis gratuit après visite sur site.',
    metaTitle: 'Ravalement de façade Péronne | Devis gratuit | Les Façadiers HDF',
    defaultVille: 'Péronne',
    highlightDept: 'Somme (80)',
  },
  'albert': {
    cityName: 'Albert',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'à Albert',
    subtitle: 'Les Façadiers HDF réalisent vos travaux de ravalement et rénovation de façade à Albert et dans la Somme. Devis gratuit après visite sur site.',
    metaTitle: 'Ravalement de façade Albert | Devis gratuit | Les Façadiers HDF',
    defaultVille: 'Albert',
    highlightDept: 'Somme (80)',
  },
  'montdidier': {
    cityName: 'Montdidier',
    h1Line1: 'Ravalement de façade',
    h1Line2: 'à Montdidier',
    subtitle: 'Les Façadiers HDF réalisent vos travaux de ravalement et rénovation de façade à Montdidier et dans la Somme. Devis gratuit après visite sur site.',
    metaTitle: 'Ravalement de façade Montdidier | Devis gratuit | Les Façadiers HDF',
    defaultVille: 'Montdidier',
    highlightDept: 'Somme (80)',
  },
};
